import loadable from '@loadable/component';

export const OrgDashboardEditJobPageContainerLoadable = loadable(
  () => import('./OrgDashboardEditJobPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardEditJobPageContainer,
  },
);
